import JDashboardLayoutBuilder from './JDashboardLayoutBuilder.vue'
import JPageLayoutBuilderSvg from './JPageLayoutBuilderSvg.vue'
import JDatatableBuilderSvg from './JDatatableBuilderSvg.vue'

// It must be exported with default to be the global component
// on the plugin feature. 
export default {
  JDashboardLayoutBuilder,
  JPageLayoutBuilderSvg,
  JDatatableBuilderSvg,
}
